export const arrivalScanTags = [
  'ArrivalScan',
] as const;
